/**
 * AUT-163: keep the first occurrence of each item by its case-insensitive
 * `search` field. The same keyword can appear in more than one SEO-insights
 * recommendation part (e.g. Top Priority and Trending), and must not be counted
 * or added to Rank Tracker twice.
 */
export function dedupeBySearch<T extends { search: string }>(items: T[]): T[] {
  const seen = new Set<string>();
  return items.filter((item) => {
    const key = item.search.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
